import { ConstraintFacilityTruckBase } from './base/constraint-facility-truck-base';

export class ConstraintFacilityTruck extends ConstraintFacilityTruckBase { }